import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { USER_LOGGED_IN } from "../../Reducer/authSlice";
import { useEffect, useState } from "react";
import API from "../../Network/API";
import { ENROLLMENT_FETCH_ERROR, ENROLLMENT_FETCH_START, ENROLLMENT_FETCH_SUCCESS } from "../../Reducer/enrollmentSlice";
import { ENROLLMENT_LESSON_FETCH_START, ENROLLMENT_LESSON_FETCH_SUCCESS } from "../../Reducer/enrollmentLessonSlice";
import { CHAT_LIST_FETCH_SUCCESS } from "../../Reducer/chatListSlice";
import UserAvatar from "../../components/UserAvatar";
import { useTranslation } from "react-i18next";
import { logout } from "../../services/Logout";

export default function StudentNav() {
    const { t } = useTranslation();
    const { user, accessToken } = useSelector((state) => state.authReducer);
    const chatlist = useSelector((state) => state.chatListReducer);
    const unread_total = chatlist?.data?.reduce((sum, c) => sum + (Number(c?.unread_count) || 0), 0) || 0;
    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const _logout = () => logout();

    useEffect(() => {
        dispatch(ENROLLMENT_FETCH_START())
        dispatch(ENROLLMENT_LESSON_FETCH_START())

          API.get(`/v1/oauth/student/my_enrollment_course`).then((response) => {
            dispatch(ENROLLMENT_FETCH_SUCCESS(response.data.data))
            dispatch(ENROLLMENT_LESSON_FETCH_SUCCESS(response.data.data))
          }).catch(() => {
            dispatch(ENROLLMENT_FETCH_ERROR())
          });

          API.get(`/v1/oauth/chatlist`).then((response) => {
            dispatch(CHAT_LIST_FETCH_SUCCESS(response.data.data))
          }).catch((error) => {
          });

      }, []);

    return (
        <>
            <div className="stickyPanelSidebar">
                <div className="settings-widget dash-profile">
                    <div className="settings-menu">
                        <div className="profile-bg">
                            <div className="profile-img">
                                <UserAvatar src={user?.avatar} name={user?.name} size={104} />
                            </div>
                        </div>
                        <div className="profile-group">
                            <div className="profile-name text-center">
                                <h4><a href="#">{user?.name}</a></h4>
                                <p>{user?.role}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="settings-widget account-settings">
                    <div className="settings-menu">
                        <h3>{t('studentNav.dashboard')}</h3>
                        <ul>
                            <li className="nav-item">
                                <NavLink to={`/home/student`} className="nav-link">
                                    <i className="fa-light fa-grid-2" />{t('studentNav.dashboard')}
                                </NavLink>
                            </li>
                            <li className="nav-item ">
                                <NavLink to={`/home/chat`} className="nav-link">
                                    <i className="fa-light fa-message-lines" />{t('studentNav.messages')}
                                    {unread_total > 0 && <span className="nav-count-badge">{unread_total}</span>}
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to={`/home/my-lessons`} className="nav-link">
                                    <i className="fa-light fa-chalkboard-user" />{t('studentNav.my_lessons')}
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to={`/home/save-course`} className="nav-link">
                                    <i className="fa-light fa-user-graduate" />{t('studentNav.saved_courses')}
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to={`/home/transactions`} className="nav-link">
                                    <i className="fa-light fa-list" />{t('studentNav.transaction_history')}
                                </NavLink>
                            </li>
                        </ul>
                        <h3>{t('studentNav.account_settings')}</h3>
                        <ul>
                            <li className="nav-item">
                                <NavLink to={`/home/settings/profile`} className="nav-link ">
                                    <i className="fa-light fa-user-gear" />{t('studentNav.settings')}
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to={`/home/help`} className="nav-link ">
                                    <i className="fa-light fa-circle-info" />{t('studentNav.help')}
                                </NavLink>
                            </li>
                            <li className="nav-item">
                            <a href="#" className="nav-link" onClick={() => _logout()}>
                                    <i className="fa-light fa-power-off" />{t('studentNav.logout')}{isLoading ? (
                                        <span
                                            className="spinner-border spinner-border-sm ml-5"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <span></span>
                                    )}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}